import { useEffect, useRef } from "react";

type Callback = (...argv: unknown[]) => void;

export const useTimeout = (callback: Callback, delay: number) => {
  const savedCallback = useRef<undefined | Callback>(undefined);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => {
      if (savedCallback.current !== undefined) {
        savedCallback.current();
      }
    };
    const id = setTimeout(tick, delay);
    return () => clearTimeout(id);
  }, [delay]);
};
